import { render, staticRenderFns } from "./RealtimeCpuMonitor.vue?vue&type=template&id=5a0a567c&"
import script from "./RealtimeCpuMonitor.vue?vue&type=script&lang=js&"
export * from "./RealtimeCpuMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports